$.widget("ui.serviceGallery", {
	options: {
		images: [],
		loader: ''
	},
	_create: function() {
		var self = this,
			o = this.options;

		o.gallLength = o.images.length;
		o.slider = this.element.find('.sliderNumber');

		if(o.gallLength == 0) {
			self.element.hide();
		} else {
			self._loadGallery();
		}
	},
	_loadGallery: function() {
		var self = this, o = this.options;
		var loader = $('#'+o.loader);
		var image = o.images[0].large;
		self.element.data('index',0);

		o.thumbs = [];
		self.element.find('.galleryThumbContainer').each(function(i) {
			o.thumbs[i] = $(this);
		});
		o.thumbs = $(o.thumbs);

		var imageContainer = $(".galleryImageLarge");
		var largeImage = this.element.find(".galleryImageLarge > img");
        var galleryHeight = imageContainer.height();
        var largeImageHeight = largeImage.height();
        var topPosition =  (galleryHeight-largeImageHeight)/2;
        largeImage.css('top', topPosition);

		largeImage.attr('src', image).load(function() {
			loader.hide();

			galleryHeight = imageContainer.height();
	        largeImageHeight = largeImage.height();
	        topPosition =  (galleryHeight-largeImageHeight)/2;
	        largeImage.css('top', topPosition);
		});

		var counter = -1;
		$.each(o.images, function(index, value) {
			counter++;
			$(o.thumbs[counter]).addClass('thumb'+index).data('image_index', 0).find('.imageLink').data('index', index);
		});

		self.element.find('.galleryImageSliderPrevious').click(function(event) {
			event.preventDefault();
			loader.show();

			if(self.element.data('index') == 0 ) {
				self.element.data('index', o.gallLength -1);
			} else {
				self.element.data('index', self.element.data('index') - 1);
			}

			largeImage.attr('src', o.images[self.element.data('index')].large);
			self._clearThumbSelect();
			o.thumbs[self.element.data('index')].addClass('active');
			self._setImageSliderNumber();
		});

		self.element.find('.galleryImageSliderNext').click(function(event) {
			event.preventDefault();
			loader.show();

			if(self.element.data('index') == o.gallLength -1) {
				self.element.data('index', 0);
			} else {
				self.element.data('index', self.element.data('index') + 1);
			}

			largeImage.attr('src', o.images[self.element.data('index')].large);
			self._clearThumbSelect();
			o.thumbs[self.element.data('index')].addClass('active');
			self._setImageSliderNumber();
		});

		self.element.find('.imageLink').click(function(event) {
			//event.preventDefault();
			loader.show();
			self.element.data('index', $(this).data('index'));
			largeImage.attr('src', o.images[self.element.data('index')].large);
			self._clearThumbSelect();
			o.thumbs[self.element.data('index')].addClass('active');
			self._setImageSliderNumber();
			return false;
		});
	},
	_clearThumbSelect: function() {
		var o = this.options;
		o.thumbs.each(function(i) {
			this.removeClass('active');
		});
	},
	_setImageSliderNumber: function() {
		var o = this.options;
		var position = parseInt(this.element.data('index'), 10) + 1;

		o.slider.html(position);
	}
});
